export default "__VITE_ASSET__B_xfGM4Y__"